<template>
  <el-container direction="vertical" class="forget-page">
    <!-- 全屏背景视频（与登录页保持一致） -->
    <video
      class="bg-video"
      src="https://mr-futrue.oss-accelerate.aliyuncs.com/PC/login-video.mp4"
      autoplay
      :muted="true"
      loop
      playsinline
      webkit-playsinline
      x5-playsinline
      preload="auto"
    ></video>

    <!-- 中间偏右的高斯模糊玻璃卡片 -->
    <div class="login-shell">
      <div class="glass-card">
    <el-form
      :model="loginForm"
      :rules="rules"
      ref="loginForm"
      label-position="left"
      label-width="0px"
      class="demo-ruleForm login-container"
    >
      <h3 class="title">忘记密码</h3>
      <el-form-item prop="phoneNum"  size="large">
        <el-input
          type="text"
          disabled="disabled"
          v-model="loginForm.phoneNum"
          auto-complete="off"
          placeholder="请输入手机号"
        >
          <template slot="prepend">+86</template>
        </el-input>
      </el-form-item>
      <el-form-item prop="user_password"  size="large">
        <el-input type="password"
                  v-model="loginForm.user_password"
                  auto-complete="off"
                  show-password
                  placeholder="请设置新的密码"></el-input>
      </el-form-item>
     <el-form-item prop="user_password1"  size="large">
        <el-input type="password"
                  v-model="loginForm.user_password1"
                  auto-complete="off"
                  show-password
                  placeholder="再次确认新的密码"></el-input>
      </el-form-item>

      <el-form-item class="center"  size="large">
        <el-button
          round
          type="primary"
          class="btnlogin width100"
          @click.native.prevent="submitForm('loginForm')"
          >找回密码</el-button
        >
      </el-form-item>
       <el-form-item class="">
        <div class="flex-center">
          记起密码?<span class="color-primary mgl-5" @click="goLogin">立即登录</span>
        </div>
      </el-form-item>
    </el-form>
      </div>
    </div>
  </el-container>
</template>

<script>
//import NProgress from 'nprogress'
import { validateTelephone, validatePass, validateCode } from "../utils/tool";
import { getCookie,delCookie } from "../utils/cookie";
import jsonp from "jsonp";
export default {
  data() {
     var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'));
      } else if (value !== this.loginForm.user_password) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    };
    return {
      logining: false,
      code:'',
      loginForm: {
        phoneNum: "",
        user_password: "",
        user_password1: "",
      },
      rules: {
        phoneNum: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          { validator: validateTelephone, trigger: "blur" },
        ],
        user_password: [
          { required: true, message: "请输入密码", trigger: "blur" },
          { validator: validatePass, trigger: "blur" },
        ],
        user_password1: [
          { validator: validatePass2, trigger: "blur" },
        ],
      },
      checked: true,
      time:0
    };
  },
  created() {
    if(!getCookie('code') || !getCookie('phone')){
      this.$message.warning('验证码过期');
      return this.$router.push("/getCode");
    }
    this.code=getCookie('code')
    this.loginForm.phoneNum=getCookie('phone')
    
  },
  methods: {
    goLogin(){
      this.$router.push("/Login");
    },
    handleReset() {
      this.$refs.loginForm.resetFields();
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$api.admincustomer
            .findPassword({
              code: this.code,
              phone:this.loginForm.phoneNum,
              pwd:this.loginForm.user_password,
            })
            .then((d) => {
              if (d.code == 200) {
                this.$message.success('修改成功，请重新登录！')
                this.$store.dispatch("set_token", '');
                this.$router.push("/Login");
              } else {
                this.$message.error(d.msg);
                delCookie('code');
                delCookie('phone');
                this.$router.push("/getCode");
              }
            })
            .catch((e) => {
              console.log(e);
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
  },
};
</script>

<style lang="scss">
/* ===== 与登录/重置页同款字体栈（说明见 Login.vue） ===== */
$puhui: "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei Light", "微软雅黑 Light",
  "Microsoft YaHei", "微软雅黑", sans-serif;
$puhui-display: $puhui;

/* 所有样式收拢在 .forget-page 之下，避免非 scoped 样式污染其它页面
   （旧版此处的全局 html body 背景与全局 .login-container 白卡会污染新登录页，已移除） */
.forget-page {
  position: relative;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  font-family: $puhui;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* 响应式基准单位：1920 宽时 = 1px，随视口宽度等比缩放，带上下限 */
  --px: clamp(0.7px, 0.05208vw, 1.12px);

  /* ===== 全屏背景视频：铺满、无遮罩、无间距 ===== */
  .bg-video {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    object-fit: cover;
    z-index: 0;
    margin: 0;
    padding: 0;
    border: none;
    display: block;
    pointer-events: none;
  }

  /* ===== 卡片容器：占据右半屏，卡片在其中水平垂直居中（卡片中心 = 视口 75% 处） ===== */
  .login-shell {
    position: absolute;
    top: 0;
    right: 0;
    z-index: 2;
    width: 50%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 calc(24 * var(--px));
    box-sizing: border-box;
  }

  /* ===== 高斯模糊玻璃卡片 ===== */
  .glass-card {
    width: 100%;
    max-width: calc(420 * var(--px));
    padding: calc(36 * var(--px)) calc(32 * var(--px)) calc(32 * var(--px));
    box-sizing: border-box;

    background: rgba(255, 255, 255, 0.3);
    -webkit-backdrop-filter: blur(26px) saturate(150%);
    backdrop-filter: blur(26px) saturate(150%);
    border-radius: calc(20 * var(--px));
    border: 1px solid rgba(255, 255, 255, 0.55);
    box-shadow: 0 20px 60px rgba(8, 44, 92, 0.28),
      inset 0 1px 0 rgba(255, 255, 255, 0.6);
    animation: cardIn 0.7s cubic-bezier(0.22, 1, 0.36, 1) both;
  }

  /* el-form 本身透明，让玻璃质感透出来 */
  .login-container {
    width: 100%;
    background: transparent;
    box-sizing: border-box;

    .title {
      font-family: $puhui-display;
      font-size: calc(26 * var(--px));
      font-weight: 300;
      letter-spacing: calc(0.5 * var(--px));
      white-space: nowrap;
      text-align: center;
      margin: 0 auto calc(32 * var(--px));
      color: #fff;
    }

    .el-form-item {
      margin-bottom: calc(25 * var(--px)); /* 预留下方校验提示空间：25 = 上6 + 提示13 + 下6 */
    }
    .el-form-item__error {
      position: absolute;
      top: 100%;
      left: 0;
      padding-top: calc(6 * var(--px));
      line-height: 1;
      color: rgba(255, 255, 255, 0.95);
      text-shadow: 0 1px 4px rgba(20, 40, 70, 0.5);
      font-size: calc(13 * var(--px));
      font-weight: 400;
    }
    .el-form-item__content {
      line-height: normal;
    }

    .el-input__inner {
      height: calc(50 * var(--px));
      line-height: calc(50 * var(--px));
      border-radius: calc(26 * var(--px));
      border: 1px solid rgba(255, 255, 255, 0.7);
      background: rgba(255, 255, 255, 0.62);
      color: #1a2b45;
      font-family: $puhui;
      font-size: calc(15 * var(--px));
      font-weight: 400;
      padding-left: calc(20 * var(--px));
      transition: all 0.25s ease;
      box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.04);

      &::placeholder {
        color: #5c6b82;
      }
      &:hover {
        background: rgba(255, 255, 255, 0.75);
        border-color: rgba(12, 113, 207, 0.5);
      }
      &:focus {
        background: rgba(255, 255, 255, 0.9);
        border-color: #0c71cf;
        box-shadow: 0 0 0 3px rgba(12, 113, 207, 0.18);
      }
    }

    /* 禁用态输入框（手机号回显不可改） */
    .el-input.is-disabled .el-input__inner {
      background: rgba(255, 255, 255, 0.35);
      border-color: rgba(255, 255, 255, 0.5);
      color: #8a97a8;
      cursor: not-allowed;

      &::placeholder {
        color: #9aa7b8;
      }
    }

    /* +86 前置槽：接玻璃卡浅色风（element-theme 的深色 prepend 不适用于恒浅色页） */
    .el-input-group__prepend {
      background: rgba(255, 255, 255, 0.5);
      border: 1px solid rgba(255, 255, 255, 0.7);
      border-right: none;
      color: #1a2b45;
      border-radius: calc(26 * var(--px)) 0 0 calc(26 * var(--px));
    }
    .el-input-group--prepend .el-input__inner {
      border-radius: 0 calc(26 * var(--px)) calc(26 * var(--px)) 0;
    }

    /* 显示密码 / 清除图标 */
    .el-input__suffix {
      right: calc(8 * var(--px));
    }
    .el-input__suffix .el-input__icon {
      font-size: calc(16 * var(--px));
      color: #5c6b82;
      line-height: calc(50 * var(--px));
    }

    /* 记起密码? 立即登录 行：视频/玻璃上白字清晰 */
    .flex-center {
      color: rgba(255, 255, 255, 0.92);
      font-size: calc(14 * var(--px));
    }
    .color-primary {
      color: #fff !important; /* 定版：链接白色（盖过公共类的品牌蓝） */
      cursor: pointer;
    }
    .color-primary:hover {
      color: rgba(255, 255, 255, 0.85) !important;
    }
  }

  /* ===== 找回密码按钮（与登录页同款） ===== */
  .center {
    margin-bottom: calc(14 * var(--px)) !important;
    text-align: center;
  }
  .btnlogin {
    width: 100%;
    height: calc(54 * var(--px));
    margin-top: calc(4 * var(--px));
    font-family: $puhui-display;
    font-size: calc(24 * var(--px));
    font-weight: 400;
    letter-spacing: calc(4 * var(--px));
    color: #292929;
    border: none;
    cursor: pointer;
    border-radius: calc(26 * var(--px));
    background: linear-gradient(135deg, #e2e7ec 0%, #c6e5e4 55%, #93b7dc 100%);
    box-shadow: 0 10px 24px rgba(20, 60, 110, 0.22);
    transition: transform 0.18s ease, box-shadow 0.18s ease, filter 0.18s ease;

    &:hover {
      filter: brightness(1.04);
      box-shadow: 0 14px 30px rgba(20, 60, 110, 0.3);
      transform: translateY(-1px);
    }
    &:active {
      transform: translateY(0);
      box-shadow: 0 6px 16px rgba(20, 60, 110, 0.22);
    }
  }

  /* 中和 Chrome 自动填充的黄色背景 */
  input:-webkit-autofill,
  input:-webkit-autofill:hover,
  input:-webkit-autofill:focus {
    -webkit-box-shadow: 0 0 0 1000px rgba(255, 255, 255, 0.62) inset;
    -webkit-text-fill-color: #1a2b45;
    caret-color: #1a2b45;
    transition: background-color 9999s ease-in-out 0s;
  }
}

/* ===== 卡片入场动画 ===== */
@keyframes cardIn {
  from {
    opacity: 0;
    transform: translateY(18px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* ===== 响应式：窄屏时右半屏放不下卡片，退回全屏居中 ===== */
@media (max-width: 900px) {
  .forget-page .login-shell {
    width: 100%;
    justify-content: center;
    padding: 0 24px;
  }
  .forget-page .login-container .title {
    font-size: calc(22 * var(--px));
    white-space: normal;
  }
}
/* 矮窗口：收紧留白（不压 el-form-item 间距，保证校验提示空间） */
@media (max-height: 720px) {
  .forget-page .glass-card {
    padding-top: 26px;
    padding-bottom: 24px;
  }
  .forget-page .login-container .title {
    margin-bottom: 24px;
  }
}
</style>